import { api } from '@src/api/api'
import { PromotionType } from '@src/store/ducks/promotion/types'

export const promotionsApi = {
  getPromotion(tariffsIds: number[]) {
    return api.get<PromotionType[]>('/v1/promotions', { tariffsIds })
  },
}
